import { useEffect } from "react";
import { useSelector } from "react-redux";
import { changeAgentChatStatusApi } from "redux/ringme-ott-sdk";

const ResetAgentChatStatus = () => {
  const agentChatStatus = useSelector(
    (state) => state.ringmeOttSdk.agentChatStatus
  );
  const agentStatus = useSelector((state) => state.agent.status);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentChatStatus = agentChatStatus || agentStatus?.statusChatId;
      if (currentChatStatus && !window.globalThis.isLogoutProcess) {
        try {
          changeAgentChatStatusApi(currentChatStatus, true);
        } catch (error) {
          console.log("error", error);
        }
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [agentChatStatus, agentStatus]);

  return null;
};

export default ResetAgentChatStatus;
